<ng-container *ngIf="{
  isLoading: isLoading$ | async
   } as data">
<div class="transactions-content flex">
  <section class="page-data w-full">
    <h3 class="heading mb-3">Transactions</h3>

    <form [formGroup]="pageForm" (keydown.enter)="$event.preventDefault()" class="list-actions-form flex justify-content-start">
      <mat-form-field appearance="outline" class="filter-form-field">
        <input matInput formControlName="filter" class="lo_sensitive" placeholder="Search by name or term" />
        <mat-icon matPrefix class="magnify-icon notranslate">search</mat-icon>
        <mat-icon matSuffix *ngIf="showClearFilter$ | async" (click)="clear('filter')"
          class="cursor-pointer notranslate" matTooltip="Clear" aria-label="Clear">clear</mat-icon>
      </mat-form-field>

      <terra-date-range-picker class="filter-form-field date-picker w-auto bg-white" (dateRangeSelected)="dateRangeChanged($event)">
      </terra-date-range-picker>

      <mat-form-field appearance="outline" class="direction-select w-8rem filter-form-field">
        <mat-select formControlName="direction" placeholder="Direction">
          <mat-option value="Debit">Debit</mat-option>
          <mat-option value="Credit">Credit</mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="showClearDirection$ | async" (click)="$event.stopPropagation(); clear('direction')"
          class="cursor-pointer notranslate" matTooltip="Clear" aria-label="Clear">clear
        </mat-icon>
      </mat-form-field>

      <terra-export-transactions-menu class="export-menu ml-auto font-medium" [exportTransactionsParameters]="exportTransactionsParameters" (exportFormat)="onExportFormatChanged($event)"></terra-export-transactions-menu>
    </form>

    <terra-loader class="page-loader block my-8 mx-auto" *ngIf="data.isLoading"></terra-loader>
    <ng-container *ngIf="!data.isLoading">

      <div *ngIf="transactions?.length" class="transactions-container">
        <ul class="p-0" *ngFor="let transaction of transactions; index as i ">
          <li class="flex py-2 px-4 bg-white" [ngClass]="{'border-dir-out': transaction.direction === transactionDirection.Debit,
          'border-dir-in': transaction.direction === transactionDirection.Credit,
          'lp-side': isLp}"
            (mouseenter)="transaction.hover = true" (mouseleave)="transaction.hover = false">
            <div class="flex-column flex-17">
              <div class="text-line font-medium icon-container">
                <mat-icon *ngIf="transaction.direction === transactionDirection.Debit"
                  class="action-icon dir-out notranslate">logout
                </mat-icon>
                <mat-icon *ngIf="transaction.direction === transactionDirection.Credit"
                  class="action-icon dir-in notranslate">login
                </mat-icon>
                <span class="unit-status inline-block">{{transaction.transactionStatus| enumString:TransactionStatus}}</span>
                <mat-icon *ngIf="transaction.recipientInfo" matTooltip="{{transaction.recipientInfo}}"
                  class="notranslate help-icon w-1rem h-1rem text-base text-center material-symbols-rounded" tooltipPosition="right"
                  matTooltipClass="terra-bank-account-details-tooltip">help</mat-icon>
              </div>
              <div class="text-faded text-line font-medium">
                {{transaction.date | date: dateFormat}}
              </div>
            </div>
            <div class="flex-column flex-65">
              <div class="flex">
                <div class="text-line font-medium">{{transaction.name}}</div>
                <div class="div-icon" *ngIf="transaction.note?.notes === null"
                  (click)="transaction.showDiv = true;transaction.hover = false;">
                  <img class="note-icon cursor-pointer" *ngIf="transaction.hover" src="assets/images/icons/maps_ugc.svg"
                    tooltipPosition="top" pTooltip="Add Note" />
                </div>
              </div>
              <div class="text-line font-normal">{{transaction.description}}</div>

              <div class="flex align-items-center notes-container" *ngIf="transaction.showDiv">
                <mat-form-field appearance="outline" class="note-form-field w-10 bg-white">
                  <input matInput [(ngModel)]="transaction.inputNotes" class="lo_sensitive" maxlength="400"
                    placeholder="Add a note here" />
                </mat-form-field>
                <div class="functionality-section-note flex align-items-center">
                  <terra-buttons type="secondary" label="Save"
                    (onClick)="transactionNotesService.saveNotesField(transaction)"></terra-buttons>
                  <img class="icon cursor-pointer" (click)="transactionNotesService.cancelTransactionNote(transaction)"
                    src="assets/images/icons/clearIcon.svg" tooltipPosition="top" pTooltip="Cancel" />
                </div>
              </div>

              <ng-container *ngIf="!transaction.loading; else notesSaveProcess">
                <div class="flex"
                  *ngIf="transaction.note?.notes !== null && transaction.showEdit"
                  (mouseleave)="transaction.showIcons=false">
                  <div class="text-line-notes text-base	font-normal line-height-2 overflow-hidden cursor-pointer" (mouseenter)="transaction.showIcons = true" tooltipPosition="bottom"
                    pTooltip="{{transaction.note?.notes}}">
                    {{transaction.note?.notes| truncate: 40:true}}
                  </div>
                  <div *ngIf="transaction.showIcons">
                    <img class="edit-icon cursor-pointer ml-1" (click)="transactionNotesService.editTransactionNote(transaction)"
                      src="assets/images/icons/editButton.svg" tooltipPosition="top" pTooltip="Edit Note" />
                    <img class="edit-icon cursor-pointer ml-1" (click)="transactionNotesService.deleteNote(transaction)"
                      src="assets/images/icons/deleteButton.svg" tooltipPosition="top" pTooltip="Delete Note" />
                  </div>
                </div>
              </ng-container>
              <ng-template #notesSaveProcess>
                <terra-loader></terra-loader>
              </ng-template>
            </div>

            <div class="flex-column flex-18">
              <div class="text-right text-line font-medium text-amount text-xl">
                {{(transaction.direction === transactionDirection.Debit ? '-' : '') + '$' + (transaction.amount
                | number : '1.2-2')}}
              </div>
              <div class="float-right text-line font-medium">
                <terra-icon-text [text]="transaction.transactionType | enumString:TransactionType"
                  [icon]="transaction.transactionType | enumIcon:TransactionType"></terra-icon-text>
              </div>
            </div>
          </li>
        </ul>

        <mat-paginator (page)="pageChange($event)" [length]="totalTransactionsNumber || transactions?.length" [hidePageSize]="true"
          [pageSize]="pageSize" [showFirstLastButtons]="true"
          [pageIndex]="pageNumber" *ngIf="totalTransactionsNumber > 0 || transactions?.length > 0">
        </mat-paginator>
        <div class="spacer"></div>
      </div>

      <div *ngIf="!transactions?.length" class="no-transactions mt-3 text-center bg-white">
        <span class="text-2xl">No transactions</span>
      </div>
    </ng-container>

  </section>
</div>
</ng-container>
